export const calculator = () => {
  const formData =
    '[{"years":{"2003":{"lo":2,"hi":3},"2004":{"lo":2.1,"hi":3},"2005":{"lo":3,"hi":3.3},"2006":{"lo":3.8,"hi":4.4},"2007":{"lo":4.6,"hi":5.5},"2008":{"lo":5.3,"hi":6.6},"2009":{"lo":5.6,"hi":6.8},"2010":{"lo":6.2,"hi":7.6},"2011":{"lo":6.7,"hi":8},"2012":{"lo":6.9,"hi":8.5},"2013":{"lo":7,"hi":8.8},"2014":{"lo":7,"hi":8.9},"2015":{"lo":7,"hi":9},"2016":{"lo":7,"hi":9},"2017":{"lo":7,"hi":9.1},"2018":{"lo":7,"hi":9.4},"2019":{"lo":7,"hi":9.7},"2020":{"lo":7,"hi":10},"2021":{"lo":7,"hi":10.2},"2022":{"lo":7,"hi":10.5}}}]';

  const calcData = JSON.parse(formData)[0].years;
  //console.log(calcData['2003'].hi);

  let hiEst = 0;
  let loEst = 0;

  $('#calculator-form')
    .find('select:not(#state), input')
    .on('change', function () {
      hiEst = Math.ceil(
        calcData[$('#year').find(':selected').val()].hi * $('#amount').val()
      );
      hiEstText = hiEst.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      $('#hi-est').text('$' + hiEstText);
      loEst = Math.floor(
        calcData[$('#year').find(':selected').val()].lo * $('#amount').val()
      );
      loEstText = loEst.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      $('#lo-est').text('$' + loEstText);
      if ($('#year').val() > 0 && $('#amount').val() > 0) {
        $('.form-output').addClass('is-shown');
      } else {
        $('.form-output').removeClass('is-shown');
      }
    });
};
